import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CommunityCircleItem from "@/components/community/components/CommunityCircleItem";
import Complaint from "./components/Complaint.vue";
import EmptyNew from "@/components/EmptyNew.vue";
import { triggerLoaded } from "@/components/LoadContainer.vue";
export default {
  name: "MemberCommnunity",
  components: {
    CommunityCircleItem: CommunityCircleItem,
    Complaint: Complaint,
    EmptyNew: EmptyNew
  },
  data: function data() {
    return {
      activeTab: this.$route.query.tab || "0",
      tabs: [{
        name: "0",
        label: "我发表的"
      }, {
        name: "1",
        label: "我参与的"
      }, {
        name: "2",
        label: "我收藏的"
      }, {
        name: "3",
        label: "我加入的"
      }],
      myGroupList: [],
      //我加入的圈子
      page: 1,
      limit: 10,
      total: 0,
      origin: "2" //1:班级圈子 2:社区

    };
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _this = this;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(this.activeTab == 3)) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return this.getMyGroup();

            case 3:
              setTimeout(function () {
                triggerLoaded(_this);
              }, 0);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    // on event
    onClickTab: function () {
      var _onClickTab = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(tab) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.activeTab = tab.name;

                if (tab.name == 3) {
                  this.getMyGroup();
                }

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onClickTab(_x) {
        return _onClickTab.apply(this, arguments);
      }

      return onClickTab;
    }(),
    onCurrentChange: function () {
      var _onCurrentChange = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(page) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.page = page;
                _context3.next = 3;
                return this.requestList();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onCurrentChange(_x2) {
        return _onCurrentChange.apply(this, arguments);
      }

      return onCurrentChange;
    }(),
    //我加入的圈子
    getMyGroup: function () {
      var _getMyGroup = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var data;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.$http.get("/api/".concat(this.$identity.getCommunityClientApiLetter(), "/community/group/myGroup"), {
                  page: this.page,
                  limit: this.limit,
                  group_type: this.origin
                });

              case 2:
                data = _context4.sent;
                this.total = data.total;
                this.myGroupList = data.data;

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getMyGroup() {
        return _getMyGroup.apply(this, arguments);
      }

      return getMyGroup;
    }(),
    onToPost: function onToPost(item) {
      this.$router.push({
        name: "CommunityShow",
        params: {
          id: item.post_id
        },
        query: {
          group_id: item.group_id,
          routeName: "MemberCommunity",
          routeLabel: "我的圈子",
          tab: this.activeTab
        }
      });
    },
    onToGroup: function onToGroup(item) {
      this.$router.push({
        name: "CommunityGroupShow",
        params: {
          id: item.group_id || item.id
        },
        query: {
          routeName: "MemberCommunity",
          routeLabel: "我的圈子",
          tab: this.activeTab
        }
      });
    },
    onExitGroup: function () {
      var _onExitGroup = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(item) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.$http.get("/api/".concat(this.$identity.getCommunityClientApiLetter(), "/community/group/outGroup/").concat(item.id));

              case 2:
                this.$success("退出圈子成功");
                _context5.next = 5;
                return this.getMyGroup();

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function onExitGroup(_x3) {
        return _onExitGroup.apply(this, arguments);
      }

      return onExitGroup;
    }(),
    onCancelCollect: function () {
      var _onCancelCollect = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(item) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.$http.put("/api/".concat(this.$identity.getCommunityClientApiLetter(), "/community/collect/").concat(item.collect_id));

              case 2:
                this.$success("取消收藏成功");
                _context6.next = 5;
                return this.getMyGroup();

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function onCancelCollect(_x4) {
        return _onCancelCollect.apply(this, arguments);
      }

      return onCancelCollect;
    }(),
    deleteCommunity: function () {
      var _deleteCommunity = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.requestList();

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function deleteCommunity() {
        return _deleteCommunity.apply(this, arguments);
      }

      return deleteCommunity;
    }(),
    onComplaint: function onComplaint(item) {
      this.$refs.complaint.show(4, item.id);
    }
  }
};